module.exports = __webpack_public_path__ + "static/media/40-4-min.6e8d94e8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/40-4-min.JPG
// module id = 1395
// module chunks = 0